import "./Home.module.css";
import ReservationForm from "./sections/ReservationForm";
import GourmetOnTheGo from "./sections/GourmetOnTheGo";
import ProgrammesSurMesure from "./sections/ProgrammesSurMesure";
import AssetQualityStandards from "./sections/AssetQualityStandards";
import CommunityStatistics from "./sections/CommunityStatistics";
import OurPrestigePartners from "./sections/OurPrestigePartners";
import ReadyForADeviceUpgrade from "./sections/ReadyForADeviceUpgrade";
import GuestTestimonials from "./sections/GuestTestimonials";
import Footer from "@/reusable_sections/Footer";
import BookingHub from "./sections/BookingHub";
import Gallery from "./sections/Gallery";
import Portfolio from "./sections/Portfolio";
import TravelHeader from "./sections/TravelHeader";
import LuxuryAmenitiesOverview from "./sections/LuxuryAmenitiesOverview";
import TemoignagesClients from "./sections/TemoignagesClients";
import NoKycCasinos from "./sections/NoKycCasinos";
export default function HomePage() {
  return <div>
      <TravelHeader />
      <NoKycCasinos />
      <GourmetOnTheGo />
      <Gallery />
      <Portfolio />
      <BookingHub />
      <ReservationForm />
      <GuestTestimonials />
      <LuxuryAmenitiesOverview />
      <ProgrammesSurMesure />
      <AssetQualityStandards />
      <CommunityStatistics />
      <OurPrestigePartners />
      <TemoignagesClients />
      <ReadyForADeviceUpgrade />
      <Footer />
    </div>;
}